module.exports = __webpack_public_path__ + "img/c-en-10.40aaa2bb.png";